import { render, staticRenderFns } from "./Anime.vue?vue&type=template&id=7fe8fd98&"
import script from "./Anime.vue?vue&type=script&lang=js&"
export * from "./Anime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports